"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteBadgeById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Delete a badge with given ID (if it exists).
 *
 * Badge is identified by its stringified `ObjectID`.
 *
 * ## Usage
 *
 * ```ts
 * const badgeId: string = "5f5e555d5a578b6";
 * const {
 * 	acknowledged,
 * 	deletedCount,
 * } = await sdk.deleteBadgeById({ bagdeId });
 * ```
 *
 * @param params.badgeId - ID of the badge to delete.
 */
const deleteBadgeById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { badgeId } = params;
    const url = `${BASE_URL}/badges/badge/${badgeId}`;
    const badgeResponse = yield axios_1.default.delete(url, { validateStatus: () => true });
    const { status, data } = badgeResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.deleteBadgeById = deleteBadgeById;
